import {FilterState} from './filters/state';
import {extend, createEmpty} from 'ol/extent';
import { inAndOut } from 'ol/easing';

//var peoples = require("./config").iedzGrupas;
/* Helper functions */

var f = {}
//recursive getProperties, gets shit out of clustered feature (always uses 1st)
f.getProps = function(feature) {
    var props = feature.getProperties();
    
    if(typeof props.features != 'undefined'){
        return f.getProps(props.features[0]);
    }
    
    return props;
}


//map instance, {id:parseInt($(this).attr("data-pk"))}, {comment:newValue}, visible / all
f.updateFeatureProps = function(map, findProps, updateProps, type) {
    
    if(typeof type === 'undefined') {
        type = 'all';
    }
    
    var layers = map.getLayers().getArray();
    
    for(var il = 0, llen = layers.length; il < llen; il++){

        var layer = layers[il];
        
        if(layer.getVisible() === true || type === 'all') {
        
            if(typeof layer.getSource().getFeatures !== 'function') { //if not object layer (wms etc)
                continue;
            }
            
            if(typeof layer.getSource().getSource === 'function') {
                var features = layer.getSource().getSource().getFeatures(); //getSource 2x to get from cluster / if no cluster then add code
            } else {
                var features = layer.getSource().getFeatures(); //getSource 2x to get from cluster / if no cluster then add code
            }
            
            
            for( var i = 0, len = features.length; i < len; i++ ){
                
                var props = features[i].getProperties(); //WIP
                if(props.id == findProps.id) {
                    
                    features[i].setProperties(updateProps);
                    break;
                }
            }
        }
        
    }   
}

f.getRadius = function(n, resolution, sliderModel, customMod) {

    if(typeof customMod === 'undefined') {
        customMod = 1;
    }

    var mod = 0.1 + 0.9 * (sliderModel.getPercent()/100);

    var intRadius = Math.sqrt(n / Math.PI) * mod * 5 * customMod;

    if(intRadius < 3)
        intRadius = 3;

    return intRadius;
}

f.centerOnFeatures = function(arrFeatures, map, padding){
    
    var extent = createEmpty();
    
    for(var i = 0, len = arrFeatures.length; i < len; i++){
        extend(extent, arrFeatures[i].getGeometry().getExtent());
    }
    
    //var pan = ol.animation.pan({duration: 500, source: map.getView().getCenter()})
    //var zoom = ol.animation.zoom({duration: 500, resolution: map.getView().getResolution()})
    //map.beforeRender(pan, zoom);
    
    map.getView().fit(extent, {padding: padding, duration: 500, easing: inAndOut});
    
    if(typeof callbackFunc != 'undefined'){
        callbackFunc(feature);
    }
}
/*
f.loopProps = function(){
    
    var childFeatures = feature.get('features');

    if(typeof childFeatures !== 'undefined' && childFeatures.length > 0){
        for(var i = 0, len = childFeatures.length; i < len; i++){
            var props = childFeatures[i].getProperties();

            for (var n = props.schools.length - 1; n >= 0; n--) {
                if(props.schools[n].name === school) {

                    count += parseInt(props.schools[n].count);
                }
            }
        }
    }else{
        var props = feature.getProperties();

        for (var i = props.schools.length - 1; i >= 0; i--) {
            if(props.schools[i].name === school) {

                count += parseInt(props.schools[i].count);
            }
        }
        
        
}*/

f.countSchoolsStudents = function(feature, school) {

    if(Array.isArray(feature)) {
        
    //  return f.countSchoolsStudents(feature[0], school);
    }
    var count = 0;
    var childFeatures = feature.get('features');
    if(typeof childFeatures !== 'undefined' && childFeatures.length > 0){
        for(var i = 0, len = childFeatures.length; i < len; i++){
            var props = childFeatures[i].getProperties();

            for (var n = props.schools.length - 1; n >= 0; n--) {
                if(props.schools[n][0] === school) {

                    count += parseInt(props.schools[n][1]);
                }
            }
        }
    }else{
        var props = feature.getProperties();

        for (var i = props.schools.length - 1; i >= 0; i--) {
            if(props.schools[i][0] === school) {

                count += parseInt(props.schools[i][1]);
            }
        }
        
        
    }
    
    return count;

}

f.countProp = function(feature, propField, filterFunc = null) {

    var many = Array.isArray(propField);

    var count = 0;
    if(Array.isArray(feature)) {
        childFeatures = feature;
    } else {
        var childFeatures = feature.get('features');
    }
    
    if(typeof childFeatures !== 'undefined' && childFeatures.length > 0){
        for(var i = 0, len = childFeatures.length; i < len; i++){
            var props = childFeatures[i].getProperties();

            if(many) {
                for (var n = propField.length - 1; n >= 0; n--) {
                    if(props[propField[n]] === null) {
                        continue;
                    }
                    count += parseInt(props[propField[n]]);
                }
            } else {
                if(props[propField] === null){
                    continue;
                }
                count += parseInt(props[propField]);
            }
            
        
        }
    }else{
        var props = feature.getProperties();

        if(many) {
            for (var n = propField.length - 1; n >= 0; n--) {
                if(propField[n] === null){
                    continue;
                }
                count += parseInt(props[propField[n]]);
            }
        } else {
            if(feature.getProperties()[propField] !== null){
                count += parseInt(props[propField]);
            }
        }
        
    }

    return count;
}

f.countSkoleni = function(feature, propField = 'kopa'){
    
    if(Array.isArray(feature)) {
        
        return f.countSkoleni(feature[0], propField);
    }

    var many = Array.isArray(propField);

    var count = 0;

    var childFeatures = feature.get('features');
    if(typeof childFeatures !== 'undefined' && childFeatures.length > 0){
        for(var i = 0, len = childFeatures.length; i < len; i++){
            var props = childFeatures[i].getProperties();
            
            if(!FilterState.filterByProps(props)){
                continue;
            }

            if(many){
                for (var n = propField.length - 1; n >= 0; n--) {
                    if(props[propField[n]] === null) {
                        continue;
                    }
                    count += parseInt(props[propField[n]]);
                }
            } else {
                if(props[propField] === null){
                    continue;
                }
                count += parseInt(props[propField]);
            }
            
        
        }
    }else{
        var props = feature.getProperties();
        if(FilterState.filterByProps(props)) {
                
            if(many) {
                for (var n = propField.length - 1; n >= 0; n--) {
                    if(propField[n] === null){
                        continue;
                    }
                    count += parseInt(props[propField[n]]);
                }
            } else {
                if(feature.getProperties()[propField] !== null){
                    count += parseInt(props[propField]);
                }
            }
        }
    }
    
    if(count === 0){
        count = '';
    }
    return count;
}

f.countVietVien = function(feature){

    var count = 0;

    var childFeatures = feature.get('features');
    if(typeof childFeatures !== 'undefined' && childFeatures.length > 0){
        for(var i = 0, len = childFeatures.length; i < len; i++){
            var props = childFeatures[i].getProperties();
            
            if(typeof props.Viet_vien_ !== 'undefined'){
                count += parseInt(props.Viet_vien_);
            }else if(typeof props.Viet_vien_ !== 'undefined'){
                count += parseInt(props.Viet_vien_);
            }
        }
    }else{
        var props = feature.getProperties();

        if(typeof props.Viet_vien_ !== 'undefined'){
            count = props.Viet_vien_;
        }else if(typeof props.Viet_vien_ !== 'undefined'){
            count = props.Viet_vien_;
        }

    }
    
    if(parseInt(count) === 0){
        count = '';
    }

    return count;
};

f.isLayerAdded = function(layer, mapref){

  var mapLayers = mapref.getLayers().getArray();

  for (var i = mapLayers.length - 1; i >= 0; i--) {
    if(mapLayers[i] === layer){
      return true;
    }
  }

  return false;
}

f.replaceAll = function(str, mapObj) {

    for (var x in mapObj) {
        str = str.replace(new RegExp(x, 'g'), mapObj[x]);
    }
    return str;
}


module.exports = f;


// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/helpers.js